/**
 * Recursively removes all properties with `undefined` or `null` values from an object or array.
 * Leaves 0, false, '', and other falsy but defined values untouched.
 */
export function removeUndefined<T>(input: T): T {
	if (Array.isArray(input)) {
		return input
			.map(removeUndefined)
			.filter((v) => v !== undefined && v !== null) as unknown as T
	}

	if (input !== null && typeof input === 'object') {
		const result: any = {}

		for (const [key, value] of Object.entries(input)) {
			if (value !== undefined && value !== null) {
				const filteredValue = removeUndefined(value)
				// Don't include empty objects or arrays unless input explicitly had them
				if (filteredValue !== undefined && filteredValue !== null) {
					result[key] = filteredValue
				}
			}
		}

		return result as T
	}

	return input
}
